module.exports = __webpack_public_path__ + "img/LATIN10_19.bf41a0d7.jpg";